export function normalizeWebsiteUrl(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";

  const candidate = /^[a-z][a-z\d+.-]*:/i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  try {
    const url = new URL(candidate);
    if (!["http:", "https:"].includes(url.protocol) || !url.hostname) return null;
    return url.href;
  } catch {
    return null;
  }
}
